import axios from "./../../config/axios";

/**
 * Fetch The currencies list from the ledger service.
 * @param {object} payload The query string as an object.
 */
export function getCurrenciesList(payload) {
    return axios().get(`/ledger/currencies`, { params: payload });
}

export default {
    index: getCurrenciesList
}